/*
 * @Descripttion: 
 * @version: 
 * @Author: HanBeiBei
 * @Date: 2020-09-05 21:51:31
 * @LastEditors: HanBeiBei
 * @LastEditTime: 2020-09-13 13:00:31
 */
import React, { Component } from 'react';
import request from "@/method/request";
import moment from "moment";
import { DatePicker } from "antd";
import "./index.scss";

const { MonthPicker } = DatePicker;

class index extends Component {
    state = {
        data: [],
        date: moment().subtract(1, 'M').format('YYYY-MM'),
    }

    componentDidMount() {
        this.getData(this.state.date)
    }

    getData = async date => {
        try {
            const year = moment(date).format('YYYY');
            const month = moment(date).format('M');
            const res = await request(`/charge/appletpv?year=${year}&month=${month}`);
            this.setState({ data: res.data || [] });
        } catch (error) {
            console.log(error);
        }
    }

    render() {
        const { data } = this.state;
        return (
            <div className="performanceReview performanceReview-applet">
                <div className="title">
                    1.5 GCH Mini Program Page View Ranking - Current Month 集团小程序当月访问量排名
                </div>
                <div>
                    <MonthPicker
                        placeholder="请选择年月"
                        monthCellContentRender={(date, local) => {
                            return moment(date).format('M月')
                        }}
                        defaultValue={moment(this.state.date, "YYYY-MM")}
                        format="YYYY-MM"
                        onChange={(date, str) => {
                            this.setState({
                                date: str,
                                data: [],
                            });
                            this.getData(str)
                        }}
                    />
                </div>
                <div className="row">
                    <div className="content">
                        <div className="title">
                            GCH Mini Program Page View Ranking TOP 20 小程序访问量排名前二十
                    </div>
                        {(data || []).map((x, i) => {
                            return (
                                <div className="item" key={x.name}>
                                    <div>{i + 1}</div>
                                    <div>
                                        {x.name}
                                    </div>
                                    <div>
                                        {x.count}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/OTAChannel/1.5/index.js